import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import Breadcrumb from '@/Components/Main/breadcrumb';
import Layout from '@/Layouts/Layout';
import { InertiaLink } from '@inertiajs/inertia-react';
import DOMPurify from 'dompurify';
import { Head, usePage } from '@inertiajs/react';
// Obrázky sú dostupné cez Laravel storage link
const ikona = '/storage/logo-ikona.png';

const formatDatum = (datum) => {
    const dateObj = new Date(datum);
    const den = String(dateObj.getDate()).padStart(2, '0');
    const mesiac = String(dateObj.getMonth() + 1).padStart(2, '0');
    const rok = dateObj.getFullYear();

    return `${den}.${mesiac}.${rok}`;
};

const formatSuma = (suma) => {
    const num = parseFloat(suma);
    if (Number.isInteger(num)) {
        return num.toString();
    }
    return num.toString();
};

const ZoznamSlug = ({ zviera, patroni, isPatron, anonympatroni, nastaveniePlatby, qrcodes }) => {
    const sectionRef = useInView({ triggerOnce: true, threshold: 0.1 });
    const [activeTab, setActiveTab] = useState('zakladne');
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenPatron, setIsOpenPatron] = useState(false);
    const [selectedImg, setSelectedImg] = useState('');
    const [selectedPopis, setSelectedPopis] = useState('');
    const [currentGalleryIndex, setCurrentGalleryIndex] = useState(0);
    const [currentGallery, setCurrentGallery] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fullText, setFullText] = useState('');

    const { url } = usePage();
    const queryParams = new URLSearchParams(url.split('?')[1]);
    const openModale = queryParams.get('openModal');
    const pageUrl = window.location.href;

    useEffect(() => {
        if (openModale === 'true') {
            openModalPatron();
        }
    }, [openModale]);

    const validVideos = zviera.videogaleria ? zviera.videogaleria.filter(video => video.video) : [];
    const validVideosPredplatne = zviera.videogaleria_obrazkov_predplatne ? zviera.videogaleria_obrazkov_predplatne.filter(video => video.video) : [];

    // Zoradenie galérií od najnovšieho (reverse)
    const validGaleria = zviera.galeria ? [...zviera.galeria.filter(obrazok => obrazok.obrazok)].reverse() : [];
    const validGaleriaPredplatne = zviera.galeria_obrazkov_predplatne ? [...zviera.galeria_obrazkov_predplatne.filter(obrazok => obrazok.obrazok)].reverse() : [];

    const openModal = (imgSrc, popis, gallery, index) => {
        setSelectedImg(imgSrc);
        setSelectedPopis(popis);
        setCurrentGallery(gallery);
        setCurrentGalleryIndex(index);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setCurrentGalleryIndex(0);
        setCurrentGallery([]);
    };

    const nextImage = () => {
        if (currentGalleryIndex < currentGallery.length - 1) {
            const nextIndex = currentGalleryIndex + 1;
            setCurrentGalleryIndex(nextIndex);
            setSelectedImg(currentGallery[nextIndex].obrazok);
            setSelectedPopis(currentGallery[nextIndex].popis || '');
        }
    };

    const prevImage = () => {
        if (currentGalleryIndex > 0) {
            const prevIndex = currentGalleryIndex - 1;
            setCurrentGalleryIndex(prevIndex);
            setSelectedImg(currentGallery[prevIndex].obrazok);
            setSelectedPopis(currentGallery[prevIndex].popis || '');
        }
    };

    // Keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!isOpen) return;
            
            if (e.key === 'ArrowRight' && currentGalleryIndex < currentGallery.length - 1) {
                const nextIndex = currentGalleryIndex + 1;
                setCurrentGalleryIndex(nextIndex);
                setSelectedImg(currentGallery[nextIndex].obrazok);
                setSelectedPopis(currentGallery[nextIndex].popis || '');
            } else if (e.key === 'ArrowLeft' && currentGalleryIndex > 0) {
                const prevIndex = currentGalleryIndex - 1;
                setCurrentGalleryIndex(prevIndex);
                setSelectedImg(currentGallery[prevIndex].obrazok);
                setSelectedPopis(currentGallery[prevIndex].popis || '');
            } else if (e.key === 'Escape') {
                closeModal();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, currentGalleryIndex, currentGallery]);

    const openModalPatron = () => {
        setIsOpenPatron(true);
    };

    const closeModalPatron = () => {
        setIsOpenPatron(false);
    };

    const handleShowMoreClick = (text) => {
        setFullText(text);
        setIsModalOpen(true);
    };

    const closeModalText = () => {
        setIsModalOpen(false);
    };

    const getEmbedUrl = (url) => {
        const videoId = url.split('youtu.be/')[1];
        return `https://www.youtube.com/embed/${videoId}`;
    };

    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return (
                <>
                    {text.slice(0, maxLength)}...
                    <span
                        onClick={() => handleShowMoreClick(text)}
                        className="font-bold cursor-pointer"
                    >
                        {' '} Pokračujte kliknutím
                    </span>
                </>
            );
        }
        return text;
    };

    const [formData, setFormData] = useState({
        meno: '',
        priezvisko: '',
        email: '',
        iban: '',
        vopgdpr: false,
        anonym: false,
        zviera_id: zviera.id,
    });
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post('/api/patron', formData);
            setIsSubmitted(true);
        } catch (error) {
            console.error('There was an error submitting the form!', error);
        }
    };

    const stripHtml = (html) => {
        return html.replace(/<[^>]*>?/gm, '');
    };

    // Funkcia na dekódovanie HTML entít pomocou DOM parsera
    const decodeHtml = (html) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    // Popis z objektu 'zviera'
    let popis = stripHtml(zviera.kratky_popis);

    // Dekóduj HTML entity
    popis = decodeHtml(popis);

    // Skráť reťazec na 149 znakov
    if (popis.length > 149) {
        popis = popis.slice(0, 149).trim() + '...';
    }

    return (
        <Layout>
            <Head title={`${zviera.meno} - Zvieratko`}>
                <meta name="description" content={ popis } />

                {/* Open Graph Meta tagy (pre Facebook, Instagram, LinkedIn) */}
                <meta property="og:title" content={`${zviera.meno} - Psí Patróni`} />
                <meta property="og:description" content={popis} />
                <meta property="og:image" content={`/storage/${zviera.fotka}`} />
                <meta property="og:url" content={pageUrl} />
                <meta property="og:type" content="website" />

                {/* Twitter Card Meta tagy */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`${zviera.meno} - Psí Patróni`} />
                <meta name="twitter:description" content={popis} />
                <meta name="twitter:image" content={`/storage/${zviera.fotka}`} />
            </Head>
            <Breadcrumb />
            <section ref={sectionRef.ref} className={`fade-in-section container mx-auto px-4 ${sectionRef.inView ? 'is-visible' : ''}`}>
                <div className="mx-auto container flex align-center">
                    <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
                        <div className="lg:col-span-2 relative">
                            <img
                                alt={zviera.meno}
                                src={`/storage/${zviera.fotka}`}
                                className="h-40 w-full object-cover sm:h-[556px] rounded-xl"
                            />
                            {isPatron ? (
                                <div className='absolute flex items-center gap-2 right-0 m-6 px-4 py-2 top-0 text-[#BE1622] text-sm bg-[#FFD4D8] rounded-3xl font-semibold'>
                                    <img src={ikona} alt="ikona" className='h-6' />
                                    Som patrónom
                                </div>
                            ) : null}
                        </div>
                        <div className="bg-white p-8 md:p-14 lg:py-14 sm:h-[556px] rounded-xl lg:col-span-3">
                            <div className="text-center md:text-left">
                                <div className='flex justify-between mb-12 items-center'>
                                    <div className='flex flex-wrap'>
                                        <h2 className="text-2xl w-full font-bold text-[#26303D] md:text-4xl mb-0 lg:mb-2 text-left">
                                            {zviera.meno}
                                        </h2>

                                        <p className='flex gap-1 lg:gap-4 items-center'>
                                            <i className="fa-solid fa-heart text-[#BE1622]"></i>
                                            <span className='text-[#667085] font-bold text-xs lg:text-base'>Zachránený {formatDatum(zviera.zachraneny)}</span>
                                        </p>
                                    </div>

                                    <div className='rounded-xl bg-[#FFF2F2] flex flex-wrap justify-center items-center py-3 px-2 text-[#BE1622]'>
                                        <p className='flex w-full justify-center items-center font-black text-4xl'>
                                            {formatSuma(zviera.suma)} €
                                        </p>
                                        <p className='flex w-full justify-center items-center font-bold text-sm'>
                                            mesačné náklady
                                        </p>
                                    </div>

                                </div>
                                <p className="text-[#667085]/80 sm:mt-4 sm:block leading-6">
                                    <span className="block mb-6">
                                        {zviera.uvodny_popis}
                                    </span>

                                    {/* Budget Progress Bar */}
                                    {zviera.budget_percent !== null && zviera.budget_percent !== undefined && (
                                        <div className="mb-6">
                                            <div className="flex justify-between items-center mb-2">
                                                <span className="text-sm font-medium text-[#26303D]">Naplnenie budgetu</span>
                                                <span className="text-sm font-bold text-[#BE1622]">{parseFloat(zviera.budget_percent).toFixed(1)}%</span>
                                            </div>
                                            <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                                                <div 
                                                    className="bg-[#BE1622] h-full rounded-full transition-all duration-300"
                                                    style={{ width: `${Math.min(100, Math.max(0, parseFloat(zviera.budget_percent)))}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    )}

                                    <h3 className='text-xl font-bold text-[#26303D] my-3'>Príbeh</h3>

                                    <span className="block mb-6">
                                        {truncateText(zviera.kratky_popis, 500)}
                                    </span>
                                </p>

                                {isPatron && (
                                    <div className="mt-4 md:mt-10 text-center">
                                        <span
                                            className="inline-block bg-[#BE1622] rounded-3xl px-24 py-4 text-sm font-semibold text-white transition"
                                        >
                                            Ste patrónom tohto zvieraťa
                                        </span>
                                    </div>
                                )}

                                {!isPatron && (
                                    <>
                                        <div className="mt-4 md:mt-10 text-center">
                                            <button onClick={() => openModalPatron()}
                                                className="inline-block bg-[#BE1622] rounded-3xl px-24 py-4 text-sm font-semibold text-white transition hover:bg-[#BE1622]/80 hover:text-white"
                                            >
                                                Stať sa patrónom
                                            </button>
                                        </div>

                                        {isOpenPatron && (
                                            <div className="justify-center items-center bg-black/35 flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                                                    <div className='mt-4 p-6 bg-white rounded-2xl shadow-lg'>
                                                        <h3 className='text-xl font-bold text-center mb-6'>Staň sa patrónom zvieraťu <span className='text-[#BE1622] text-2xl'>{zviera.meno}</span></h3>
                                                        {!isSubmitted ? (
                                                            <form onSubmit={handleSubmit} className="space-y-4">
                                                                <div className='flex justify-between gap-4'>
                                                                    <div className='flex flex-col flex-nowrap'>
                                                                        <label className="block text-gray-700">Meno</label>
                                                                        <input
                                                                            type="text"
                                                                            name="meno"
                                                                            value={formData.meno}
                                                                            onChange={handleChange}
                                                                            className="mt-1 p-2 w-full border rounded-md"
                                                                            required
                                                                        />
                                                                    </div>

                                                                    <div className='flex flex-col flex-nowrap'>
                                                                        <label className="block text-gray-700">Priezvisko</label>
                                                                        <input
                                                                            type="text"
                                                                            name="priezvisko"
                                                                            value={formData.priezvisko}
                                                                            onChange={handleChange}
                                                                            className="mt-1 p-2 w-full border rounded-md"
                                                                            required
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <label className="block text-gray-700">Email</label>
                                                                    <input
                                                                        type="email"
                                                                        name="email"
                                                                        value={formData.email}
                                                                        onChange={handleChange}
                                                                        className="mt-1 p-2 w-full border rounded-md"
                                                                        required
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-gray-700">IBAN</label>
                                                                    <input
                                                                        type="text"
                                                                        name="iban"
                                                                        placeholder='Formát ibanu: SK8975000000000012345671'
                                                                        value={formData.iban}
                                                                        onChange={handleChange}
                                                                        className="mt-1 p-2 w-full border rounded-md"
                                                                    />
                                                                </div>
                                                                <div className="flex items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="vopgdpr"
                                                                        checked={formData.vopgdpr}
                                                                        onChange={handleChange}
                                                                        className="mr-2"
                                                                        required
                                                                    />
                                                                    <label className="text-gray-700">Súhlasím s VOP a GDPR</label>
                                                                </div>
                                                                <div className="flex items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="anonym"
                                                                        checked={formData.anonym}
                                                                        onChange={handleChange}
                                                                        className="mr-2"
                                                                    />
                                                                    <label className="text-gray-700">Chcem byť anonymný darca</label>
                                                                </div>
                                                                <div className="flex justify-end space-x-4">
                                                                    <button
                                                                        type="submit"
                                                                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-700 transition"
                                                                    >
                                                                        Presunúť na platbu
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={closeModalPatron}
                                                                        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-500/[.6] transition"
                                                                    >
                                                                        Zavrieť
                                                                    </button>
                                                                </div>
                                                            </form>
                                                        ) : (
                                                            <div className="text-center">
                                                                <h2 className="text-2xl font-semibold mb-4 text-center">Budeme radi ak nás podporíte a stanete sa patrónom</h2>
                                                                <div className="mb-4">
                                                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(nastaveniePlatby.popis) }}></div>
                                                                    <p className='text-green-500'>Variabilný symbol: {zviera.id}</p>
                                                                    {qrcodes && qrcodes.length > 0 ? (
                                                                        <>
                                                                            <h3 className='text-xl mt-10'>Podporte cez QR kód</h3>
                                                                            <div className='flex gap-2'>
                                                                                {qrcodes.map((qrcode, index) => (
                                                                                    <div key={index} className='flex flex-col flex-nowrap'>
                                                                                        <p>{index === 0 ? "Transparentný účet:" : index === 1 ? "Bežný účet - pre anonymných darcov:" : "Iné"}</p>
                                                                                        <img src={`${qrcode}`} alt="QR code" />
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </div>
                                                                <div className="flex justify-center space-x-4 py-3">
                                                                    <button
                                                                        type="button"
                                                                        onClick={closeModalPatron}
                                                                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-700 transition"
                                                                    >
                                                                        Zaplatené
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='mx-auto container mt-10'>
                    <div className='flex justify-center'>
                        <button
                            className={`px-6 py-4 text-center rounded-tl-lg border-t border-l border-[#EAEBF0] items-center flex gap-2 ${activeTab === 'zakladne' ? 'bg-white' : 'bg-[#ECEFF4]'}`}
                            onClick={() => setActiveTab('zakladne')}
                        >
                            <i className={`fa-solid fa-circle text-[8px] ${activeTab === 'zakladne' ? 'text-[#BE1622]' : 'text-transparent'}`}></i>
                            <span className='text-[#171D24] font-bold'>Základné informácie</span>
                        </button>
                        <button
                            className={`px-6 py-4 text-center rounded-tr-lg border-t border-r border-[#EAEBF0] items-center flex gap-2 ${activeTab === 'patroni' ? 'bg-white' : 'bg-[#ECEFF4]'} ${!isPatron ? 'cursor-not-allowed opacity-50' : ''}`}
                            onClick={() => isPatron && setActiveTab('patroni')}
                            disabled={!isPatron}
                        >
                            <i className={`fa-solid fa-circle text-[8px] ${activeTab === 'patroni' ? 'text-[#BE1622]' : 'text-transparent'}`}></i>
                            <span className='text-[#171D24] font-bold'>Obsah pre patrónov</span>
                        </button>
                    </div>
                    <div className='rounded-xl bg-white py-6'>
                        {activeTab === 'zakladne' && (
                            <div>
                                {/* Obsah pre záložku "Základné informácie" */}
                                <details className="group [&_summary::-webkit-details-marker]:hidden border-b border-[#EEF0F3] py-4 px-4" open>
                                    <summary
                                        className="flex cursor-pointer items-center justify-between gap-1.5 rounded-lg p-4 text-[#26303D]"
                                    >
                                        <h2 className="font-medium flex gap-6 items-center">
                                            <span className='text-4xl'>Galéria</span>
                                            <svg
                                                className="size-5 font-bold shrink-0 transition duration-300 group-open:-rotate-180"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </h2>
                                    </summary>
                                    <div className="mt-4 px-4 leading-relaxed text-gray-700 grid lg:grid-cols-5 gap-6">
                                        {validGaleria.length > 0 ? (
                                            <>
                                                {validGaleria.map((obrazok, index) => (
                                                    <img
                                                        key={index}
                                                        src={`/storage/${obrazok.obrazok}`}
                                                        alt={`Galéria - ${index + 1}`}
                                                        className='h-[230px] w-full rounded-xl object-cover cursor-pointer'
                                                        onClick={() => openModal(obrazok.obrazok, obrazok.popis, validGaleria, index)}
                                                    />
                                                ))}
                                            </>
                                        ) : (
                                            <p className="mt-4 px-4 leading-relaxed text-gray-700">Žiadne obrázky k dispozícii.</p>
                                        )}

                                        {isOpen && (
                                            <div className="justify-center items-center bg-black/35 flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                                                    {/* Predchádzajúci obrázok */}
                                                    {currentGalleryIndex > 0 && (
                                                        <button 
                                                            onClick={prevImage}
                                                            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-3 text-[#BE1622] text-2xl z-10 transition"
                                                            aria-label="Predchádzajúci obrázok"
                                                        >
                                                            <i className="fa-solid fa-chevron-left"></i>
                                                        </button>
                                                    )}
                                                    
                                                    {/* Ďalší obrázok */}
                                                    {currentGalleryIndex < currentGallery.length - 1 && (
                                                        <button 
                                                            onClick={nextImage}
                                                            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-3 text-[#BE1622] text-2xl z-10 transition"
                                                            aria-label="Ďalší obrázok"
                                                        >
                                                            <i className="fa-solid fa-chevron-right"></i>
                                                        </button>
                                                    )}
                                                    
                                                    <img src={`/storage/${selectedImg}`} alt="Fullscreen" className="rounded-xl max-h-[75vh] mx-auto" />
                                                    <p className='mt-4 p-4 bg-white rounded-2xl'>
                                                        {selectedPopis}
                                                    </p>
                                                    
                                                    {/* Počítadlo obrázkov */}
                                                    {currentGallery.length > 1 && (
                                                        <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-4 py-2 rounded-full text-sm">
                                                            {currentGalleryIndex + 1} / {currentGallery.length}
                                                        </div>
                                                    )}
                                                    
                                                    <button onClick={closeModal} className="absolute top-2 right-2 text-white text-3xl z-10">
                                                        <i className="fa-solid fa-circle-xmark text-[#BE1622] text-shadow-md"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </details>

                                <details className="group [&_summary::-webkit-details-marker]:hidden border-b border-[#EEF0F3] py-4 px-4" open>
                                    <summary
                                        className="flex cursor-pointer items-center justify-between gap-1.5 rounded-lg p-4 text-[#26303D]"
                                    >
                                        <h2 className="font-medium flex gap-6 items-center">
                                            <span className='text-4xl'>Kto aktuálne podporuje</span>
                                            <svg
                                                className="size-5 font-bold shrink-0 transition duration-300 group-open:-rotate-180"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </h2>
                                    </summary>
                                    <p className="mt-4 px-4 leading-relaxed text-gray-700">
                                        {anonympatroni.length > 0 ? (
                                            <>
                                                <p className='flex gap-4'>Anonymný darcovia <span className='text-center items-center justify-center flex w-fit gap-2 bg-[#BE1622] text-white rounded-full px-4'>{anonympatroni.length}</span></p>

                                            </>
                                        ) : null}

                                        {patroni.map((patron, index) => (
                                            <div key={index} className="mb-2">
                                                {patron.meno} {patron.priezvisko}
                                            </div>
                                        ))}
                                    </p>
                                </details>

                                <details className="group [&_summary::-webkit-details-marker]:hidden border-b border-[#EEF0F3] py-4 px-4" open>
                                    <summary
                                        className="flex cursor-pointer items-center justify-between gap-1.5 rounded-lg p-4 text-[#26303D]"
                                    >
                                        <h2 className="font-medium flex gap-6 items-center">
                                            <span className='text-4xl'>Náklady</span>
                                            <svg
                                                className="size-5 font-bold shrink-0 transition duration-300 group-open:-rotate-180"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </h2>
                                    </summary>
                                    <div className='w-full px-4'>
                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(zviera.popis) }}></div>
                                    </div>
                                </details>

                                {validVideos.length > 0 ? (
                                    <details className="group [&_summary::-webkit-details-marker]:hidden border-b border-[#EEF0F3] py-4 px-4">
                                        <summary
                                            className="flex cursor-pointer items-center justify-between gap-1.5 rounded-lg p-4 text-[#26303D]"
                                        >
                                            <h2 className="font-medium flex gap-6 items-center">
                                                <span className='text-4xl'>Videogaléria</span>
                                                <svg
                                                    className="size-5 font-bold shrink-0 transition duration-300 group-open:-rotate-180"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 24 24"
                                                    stroke="currentColor"
                                                >
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </h2>
                                        </summary>
                                        {validVideos.length > 0 ? (
                                            <div className="mt-4 px-4 leading-relaxed text-gray-700 grid lg:grid-cols-3 gap-6">
                                                {validVideos.map((video, index) => (
                                                    <div key={index} className='w-full flex flex-col'>
                                                        <div className='w-full h-[230px] rounded-xl overflow-hidden'>
                                                            <iframe
                                                                width="100%"
                                                                height="230"
                                                                src={getEmbedUrl(video.video)}
                                                                title={`YouTube video player ${index}`}
                                                                frameBorder="0"
                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                allowFullScreen
                                                                className="w-full h-full"
                                                            ></iframe>
                                                        </div>
                                                        {video.popis && (
                                                            <p className='mt-2 p-3 bg-gray-50 rounded-lg text-sm text-gray-700'>
                                                                {video.popis}
                                                            </p>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="mt-4 px-4 leading-relaxed text-gray-700">Žiadne videá k dispozícii.</p>
                                        )}

                                    </details>
                                ) : (null)}
                            </div>
                        )}
                        {activeTab === 'patroni' && (
                            <div>
                                {/* Obsah pre záložku "Obsah pre patrónov" */}
                                <details className="group [&_summary::-webkit-details-marker]:hidden border-b border-[#EEF0F3] py-4 px-4" open>
                                    <summary
                                        className="flex cursor-pointer items-center justify-between gap-1.5 rounded-lg p-4 text-[#26303D]"
                                    >
                                        <h2 className="font-medium flex gap-6 items-center">
                                            <span className='text-4xl'>Galéria</span>
                                            <svg
                                                className="size-5 font-bold shrink-0 transition duration-300 group-open:-rotate-180"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </h2>
                                    </summary>
                                    <div className="mt-4 px-4 leading-relaxed text-gray-700 grid lg:grid-cols-5 gap-6">
                                        {validGaleriaPredplatne.length > 0 ? (
                                            <>
                                                {validGaleriaPredplatne.map((obrazok, index) => (
                                                    <img
                                                        key={index}
                                                        src={`/storage/${obrazok.obrazok}`}
                                                        alt={`Galéria - ${index + 1}`}
                                                        className='h-[230px] w-full rounded-xl object-cover cursor-pointer'
                                                        onClick={() => openModal(obrazok.obrazok, obrazok.popis, validGaleriaPredplatne, index)}
                                                    />
                                                ))}
                                            </>
                                        ) : (
                                            <p className="mt-4 px-4 leading-relaxed text-gray-700">Žiadne obrázky k dispozícii.</p>
                                        )}

                                        {isOpen && (
                                            <div className="justify-center items-center bg-black/35 flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                                                    {/* Predchádzajúci obrázok */}
                                                    {currentGalleryIndex > 0 && (
                                                        <button 
                                                            onClick={prevImage}
                                                            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-3 text-[#BE1622] text-2xl z-10 transition"
                                                            aria-label="Predchádzajúci obrázok"
                                                        >
                                                            <i className="fa-solid fa-chevron-left"></i>
                                                        </button>
                                                    )}
                                                    
                                                    {/* Ďalší obrázok */}
                                                    {currentGalleryIndex < currentGallery.length - 1 && (
                                                        <button 
                                                            onClick={nextImage}
                                                            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-3 text-[#BE1622] text-2xl z-10 transition"
                                                            aria-label="Ďalší obrázok"
                                                        >
                                                            <i className="fa-solid fa-chevron-right"></i>
                                                        </button>
                                                    )}
                                                    
                                                    <img src={`/storage/${selectedImg}`} alt="Fullscreen" className="rounded-xl max-h-[75vh] mx-auto" />
                                                    <p className='mt-4 p-4 bg-white rounded-2xl'>
                                                        {selectedPopis}
                                                    </p>
                                                    
                                                    {/* Počítadlo obrázkov */}
                                                    {currentGallery.length > 1 && (
                                                        <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-4 py-2 rounded-full text-sm">
                                                            {currentGalleryIndex + 1} / {currentGallery.length}
                                                        </div>
                                                    )}
                                                    
                                                    <button onClick={closeModal} className="absolute top-2 right-2 text-white text-3xl z-10">
                                                        <i className="fa-solid fa-circle-xmark text-[#BE1622] text-shadow-md"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </details>

                                <details className="group [&_summary::-webkit-details-marker]:hidden border-b border-[#EEF0F3] py-4 px-4" open>
                                    <summary
                                        className="flex cursor-pointer items-center justify-between gap-1.5 rounded-lg p-4 text-[#26303D]"
                                    >
                                        <h2 className="font-medium flex gap-6 items-center">
                                            <span className='text-4xl'>Náklady</span>
                                            <svg
                                                className="size-5 font-bold shrink-0 transition duration-300 group-open:-rotate-180"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </h2>
                                    </summary>
                                    <div className='w-full px-4'>
                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(zviera.popis) }}></div>
                                    </div>
                                </details>

                                {validVideosPredplatne.length > 0 ? (
                                    <details className="group [&_summary::-webkit-details-marker]:hidden border-b border-[#EEF0F3] py-4 px-4">
                                        <summary
                                            className="flex cursor-pointer items-center justify-between gap-1.5 rounded-lg p-4 text-[#26303D]"
                                        >
                                            <h2 className="font-medium flex gap-6 items-center">
                                                <span className='text-4xl'>Videogaléria</span>
                                                <svg
                                                    className="size-5 font-bold shrink-0 transition duration-300 group-open:-rotate-180"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 24 24"
                                                    stroke="currentColor"
                                                >
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </h2>
                                        </summary>

                                        {validVideosPredplatne.length > 0 ? (
                                            <div className="mt-4 px-4 leading-relaxed text-gray-700 grid lg:grid-cols-3 gap-6">
                                                {validVideosPredplatne.map((video, index) => (
                                                    <div key={index} className='w-full flex flex-col'>
                                                        <div className='w-full h-[230px] rounded-xl overflow-hidden'>
                                                            <iframe
                                                                width="100%"
                                                                height="230"
                                                                src={getEmbedUrl(video.video)}
                                                                title={`YouTube video player ${index}`}
                                                                frameBorder="0"
                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                allowFullScreen
                                                                className="w-full h-full"
                                                            ></iframe>
                                                        </div>
                                                        {video.popis && (
                                                            <p className='mt-2 p-3 bg-gray-50 rounded-lg text-sm text-gray-700'>
                                                                {video.popis}
                                                            </p>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="mt-4 px-4 leading-relaxed text-gray-700">Žiadne videá k dispozícii.</p>
                                        )}
                                    </details>
                                ) : (null)}
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl">
                        <p>{fullText}</p>
                        <button
                            onClick={closeModalText}
                            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg"
                        >
                            Zavrieť
                        </button>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default ZoznamSlug;
